import { render, staticRenderFns } from "./KbDetailsModal.vue?vue&type=template&id=dd5a035e&scoped=true"
import script from "./KbDetailsModal.vue?vue&type=script&lang=js"
export * from "./KbDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./KbDetailsModal.vue?vue&type=style&index=0&id=dd5a035e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5a035e",
  null
  
)

export default component.exports